const s = {
  name: "Brazil",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,4H0v2h2v2.7l6,2V20H6v4h2v-2h7v2h2v-4h-1v-9.3l6-2V6h2V4h-9V3c0-1.7-1.3-3-3-3S9,1.3,9,3V4z M11,3
			c0-0.6,0.4-1,1-1s1,0.4,1,1v1c0,0.6-0.4,1-1,1s-1-0.4-1-1V3z M14.2,6H20v1.3l-6,2v6.1l-4-2V9.3l-6-2V6h5.8c0.5,0.6,1.3,1,2.2,1
			S13.7,6.6,14.2,6z M10,20v-4.4l4,2V20H10z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Brazil
};
